import { Component, Input } from '@angular/core';

@Component({
	selector: 'circle',
	template: ` <div [attr.outline]="outline"></div> `,
	styleUrls: ['./circle.component.scss'],
})
export class CircleComponent {
	@Input()
	outline = false;
}
